var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.833984,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5604F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.168 11.7207C18.3452 11.7228 16.5978 12.4478 15.3089 13.7366C14.02 15.0255 13.295 16.773 13.293 18.5957C13.293 24.4785 19.543 28.9215 19.8094 29.1074C19.9145 29.181 20.0397 29.2205 20.168 29.2205C20.2963 29.2205 20.4215 29.181 20.5266 29.1074C20.793 28.9215 27.043 24.4785 27.043 18.5957C27.0409 16.773 26.3159 15.0255 25.027 13.7366C23.7382 12.4478 21.9907 11.7228 20.168 11.7207ZM20.168 16.0957C20.6624 16.0957 21.1458 16.2423 21.5569 16.517C21.968 16.7917 22.2884 17.1822 22.4777 17.639C22.6669 18.0958 22.7164 18.5985 22.6199 19.0834C22.5235 19.5684 22.2854 20.0138 21.9357 20.3635C21.5861 20.7131 21.1406 20.9512 20.6557 21.0477C20.1707 21.1441 19.6681 21.0946 19.2113 20.9054C18.7544 20.7162 18.364 20.3958 18.0893 19.9846C17.8146 19.5735 17.668 19.0902 17.668 18.5957C17.668 17.9327 17.9314 17.2968 18.4002 16.8279C18.869 16.3591 19.5049 16.0957 20.168 16.0957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.3063da0d7809f597905bc1887987feaf.svg";
export { ForwardRef as ReactComponent };